import { groupBy } from 'lodash-es';

import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';

import { makeLogicalCondition } from './makeLogicalCondition';
import { splitConditions } from './splitConditions';

export const processLogicalConditions = (toothConditions: Condition[]) => {
  const { conditions, childrenConditions } = splitConditions(toothConditions);

  const logicalConditions = Object.entries(conditions).flatMap(
    ([code, groupedConditions]) => {
      const children = childrenConditions[code];
      const childrenGroupedByCode = groupBy(children, 'Code');

      const logicalCondition = makeLogicalCondition(groupedConditions);

      const logicalChildrenCondition = Object.values(
        childrenGroupedByCode,
      ).flatMap(makeLogicalCondition);

      // WARN: add merged child conditions into parent
      logicalCondition.Children = logicalChildrenCondition;

      return logicalCondition;
    },
  );

  const orphanChildrenConditions = Object.entries(childrenConditions).flatMap(
    ([parentCode, children]) => {
      if (parentCode in conditions) {
        return [];
      }

      return Object.values(groupBy(children, 'Code')).flatMap(
        makeLogicalCondition,
      );
    },
  );

  return [...logicalConditions, ...orphanChildrenConditions];
};
